<template>
  <div class="wrapper">
    <div class="main">
      <div class="container">
        <div class="intro">
          <div class="user-warp img">
            <img src="../assets/touxiang.jpg" alt="vx114322" />
          </div>
          <br />
          <div class="nickname">
            可语音讲解，可加/减页面，包运行，包改错，接各种项目，包至上线前或交作业前，价格公道！！
          </div>
          <br />
          <div class="description">
            <p>“既然乾坤已定 那就试着扭转乾坤吧！”</p>
          </div>
          <div class="zuobiao">
            <i class="ico_map"></i>
            <span>明/黑</span>
            <span style="margin-left: 10px">
              <input
                id="switch_default"
                type="checkbox"
                class="switch_default"
              />
              <label for="switch_default" class="toggleBtn"></label>
            </span>
          </div>
          <div class="menu navbar-right links">
            <br />
          </div>
          <div style="line-height: 20px; font-size: 9pt">
            <p style="margin-left: 8rem; font-size: 8pt">
              <small>—— 太阳程序科技 </small>
            </p>
          </div>
          <br />
          <center>
            <ul id="donateBox" class="list pos-f tr3">
              <li id="AliPay">AliPay</li>
              <li id="WeChat">WeChat</li>
              <li id="QQ">QQ</li>
            </ul>
            <div id="QRBox" class="pos-f left-100">
              <div id="MainBox"></div>
            </div>
          </center>
        </div>
      </div>
    </div>
    <footer id="footer" class="footer">
      <div class="stars">
        <div class="star"></div>
        <div class="star"></div>
        <div class="star"></div>
        <div class="star"></div>
        <div class="star"></div>
        <div class="star"></div>
        <div class="star"></div>
        <div class="star"></div>
        <div class="star"></div>
        <div class="star"></div>
        <div class="star"></div>
        <div class="star"></div>
        <div class="star"></div>
        <div class="star"></div>
        <div class="star"></div>
        <div class="star"></div>
        <div class="star"></div>
        <div class="star"></div>
        <div class="star"></div>
        <div class="star"></div>
        <div class="star"></div>
        <div class="star"></div>
        <div class="star"></div>
        <div class="star"></div>
        <div class="star"></div>
        <div class="star"></div>
        <div class="star"></div>
        <div class="star"></div>
        <div class="star"></div>
        <div class="star"></div>
        <div class="star"></div>
        <div class="star"></div>
        <div class="star"></div>
        <div class="star"></div>
        <div class="star"></div>
        <div class="star"></div>
        <div class="star"></div>
        <div class="star"></div>
        <div class="star"></div>
        <div class="star"></div>
        <div class="star"></div>
        <div class="star"></div>
        <div class="star"></div>
        <div class="star"></div>
        <div class="star"></div>
        <div class="star"></div>
        <div class="star"></div>
        <div class="star"></div>
        <div class="star"></div>
        <div class="star"></div>
      </div>
    </footer>
  </div>
</template>

<script>
import $ from "../js/jquery.min.js";

export default {
  name: "ShopdmLunbotu",

  data() {
    return {};
  },

  mounted() {
    var that = this;
    var QRBox = $("#QRBox");
    var MainBox = $("#MainBox");
    var AliPayQR = "https://pic.imgdb.cn/item/62dcb56bf54cd3f93751d058.jpg";
    var WeChanQR = "https://pic.imgdb.cn/item/62dcb4b8f54cd3f9374e287e.jpg";
    var QQQR = "https://pic.imgdb.cn/item/62dcb4b8f54cd3f9374e288a.png";

    function showQR(QR) {
      if (QR) {
        MainBox.css("background-image", "url(" + QR + ")");
      }
      $("#DonateText,#donateBox,#github").addClass("blur");
      QRBox.fadeIn(300, function (argument) {
        MainBox.addClass("showQR");
      });
    }

    $("#donateBox>li").click(function (event) {
      var thisID = $(this).attr("id");
      if (thisID === "AliPay") {
        showQR(AliPayQR);
      } else if (thisID === "WeChat") {
        showQR(WeChanQR);
      } else if (thisID === "QQ") {
        showQR(QQQR);
      }
    });

    MainBox.click(function (event) {
      MainBox.removeClass("showQR").addClass("hideQR");
      setTimeout(function (a) {
        QRBox.fadeOut(300, function (argument) {
          MainBox.removeClass("hideQR");
        });
        $("#DonateText,#donateBox,#github").removeClass("blur");
      }, 600);
    });

    let _Blog = window._Blog || {};
    const currentTheme =
      window.localStorage && window.localStorage.getItem("theme");
    const isDark = currentTheme === "dark";
    if (isDark) {
      document.getElementById("switch_default").checked = true;
    } else {
      document.getElementById("switch_default").checked = false;
    }
    _Blog.toggleTheme = function () {
      if (isDark) {
        document.querySelector("body").classList.add("dark-theme");
      } else {
        document.querySelector("body").classList.remove("dark-theme");
      }
      document
        .getElementsByClassName("toggleBtn")[0]
        .addEventListener("click", () => {
          if (document.querySelector("body").classList.contains("dark-theme")) {
            document.querySelector("body").classList.remove("dark-theme");
          } else {
            document.querySelector("body").classList.add("dark-theme");
          }
          window.localStorage &&
            window.localStorage.setItem(
              "theme",
              document.querySelector("body").classList.contains("dark-theme")
                ? "dark"
                : "light"
            );
          that.$bus.$emit("theme-change", localStorage.getItem("theme"));
        });
    };
    _Blog.toggleTheme();
  },

  methods: {},
};
</script>

<style lang="less" scoped>
* {
  letter-spacing: 0.08rem;
  padding: 0;
  margin: 0;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

::selection {
  background-color: #28df99;
  color: #f9f9f9;
}

*:focus {
  outline: none;
}

html {
  min-height: 100%;
}

body {
  max-width: 720px;
  padding: 0 10px;
  font: 400 16px/1.7 PingFang SC, sans-serif;
  color: #444;
  margin: 0 auto;
  overflow-x: hidden;
}

.dark-theme {
  max-width: 720px;
  padding: 0 20px;
  background-color: #292a2d;
  color: #a9a9b3;
  transition: color 0.2s ease, border-color 0.2s ease, background 0.2s ease,
    opacity 0.2s ease;
}

a {
  text-decoration: none;
  color: #111;
  word-wrap: break-word;
  -moz-text-decoration-color: rgba(0, 0, 0, 0.4);
  text-decoration-color: rgba(0, 0, 0, 0.4);
}

a:hover {
  text-decoration: none;
  color: #555;
  -moz-text-decoration-color: rgba(0, 0, 0, 0.6);
  text-decoration-color: rgba(0, 0, 0, 0.6);
}

.zuobiao i {
  line-height: 1.8;
  margin-right: 6px;
  vertical-align: middle;
  background-image: url(../img/zuobiao.svg);
  background-size: 100%;
  width: 16px;
  height: 16px;
  display: inline-block;
  margin-top: -2px;
}

.user-warp img {
  width: 70px;
  border-radius: 100%;
}

.dark-theme .user-warp img {
  width: 70px;
  border-radius: 100%;
  animation: light 5s ease-in-out infinite;
  transition: 0.5s;
}

@keyframes light {
  0% {
    box-shadow: 0 0 4px #f00;
  }
  25% {
    box-shadow: 0 0 5px #0f0;
  }
  50% {
    box-shadow: 0 0 4px #00f;
  }
  75% {
    box-shadow: 0 0 5px #0f0;
  }
  100% {
    box-shadow: 0 0 4px #f00;
  }
}

.menu-item {
  display: inline-block;
  height: 26px;
  line-height: 26px;
}

.links {
  font-family: miranafont, "Hiragino Sans GB", STXihei, "Microsoft JhengHei",
    SimSun, sans-serif;
  margin-bottom: 80px;
}

html {
  line-height: 1.15;
  -webkit-text-size-adjust: 100%;
}

html {
  font-family: "Microsoft Jhenghei", Lantinghei SC, "lanting", PingFang SC,
    Seguo UI, Microsoft Yahei, Arial;
}

html::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

html::-webkit-scrollbar-thumb {
  width: 8px;
  height: 68px;
  background-color: #a9a9b3;
  border-radius: 16px;
}

html::-webkit-scrollbar-thumb:hover {
  background-color: #a9a9b3;
}

body {
  margin: 0 auto;
  font-size: 11pt;
  font-weight: normal;
  line-height: 2.5em;
  background-color: #fcfefe;
  color: #161209;
  transition: color 0.2s ease, border-color 0.2s ease, background 0.2s ease,
    opacity 0.2s ease;
}

a {
  color: #161209;
  text-decoration: none;
  transition: color 0.2s ease, border-color 0.2s ease, background 0.2s ease,
    opacity 0.2s ease;
  cursor: pointer;
}

a:hover {
  color: #28df99;
  text-decoration: none;
  transition: color 0.2s ease, border-color 0.2s ease, background 0.2s ease,
    opacity 0.2s ease;
}

.dark-theme a {
  color: #a9a9b3;
  text-decoration: none;
  transition: color 0.2s ease, border-color 0.2s ease, background 0.2s ease,
    opacity 0.2s ease;
}

.dark-theme a:hover {
  color: #28df99;
  text-decoration: none;
  transition: color 0.2s ease, border-color 0.2s ease, background 0.2s ease,
    opacity 0.2s ease;
}

.wrapper {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 70vh;
  .main {
    margin: 0 auto;
    flex-grow: 1;
    flex-shrink: 0;
    flex-basis: auto;
  }
}

.container {
  padding-left: 1em;
  padding-right: 1em;
}

.footer {
  position: relative;
  z-index: -1;
  height: 6rem;
  width: 100%;
  text-align: center;
  padding-top: 2em;
  font-size: 12px;
  margin-top: 15vh;
  margin-bottom: 65px;
}

input[type="checkbox"]:checked + label:after {
  transition: all 0.3s ease-in;
}

input[type="checkbox"]:not(:checked) + label:after {
  transition: all 0.3s ease-out;
}

input[type="checkbox"]:checked + label,
input[type="checkbox"]:not(:checked) + label {
  transition: all 0.3s ease-in-out;
}

input[type="checkbox"]:checked + label:before,
input[type="checkbox"]:not(:checked) + label i:before,
input[type="checkbox"]:not(:checked) + label i:after,
input[type="checkbox"]:not(:checked) + label:before {
  transition: all 0.3s ease-in-out;
}

input[type="radio"]:not(:checked) + label:after {
  transition: all 0.3s ease-in-out;
}

.switch_default[type="checkbox"] {
  display: none;
}

.switch_default + label {
  background-color: #292a2d;
  border-radius: 7px;
  cursor: pointer;
  display: inline-block;
  height: 14px;
  position: relative;
  box-shadow: 0.2px 0.2px 1px 0.5px rgb(180, 180, 180);
  width: 30px;
}

.switch_default + label:after {
  background-color: #fff;
  border-radius: 50%;
  content: "";
  height: 12px;
  left: 1px;
  position: absolute;
  top: 1px;
  width: 12px;
  box-shadow: 0.2px 0.2px 1px 0.5px rgb(180, 180, 180);
}

.switch_default:checked + label {
  background-color: #28df99;
  box-shadow: none;
}

.switch_default:checked + label:after {
  left: 17px;
}

@font-face {
  font-family: "iconfont";

  /* IE9 */
  src:
    /* IE6-IE8 */ url("data:application/x-font-woff2;charset=utf-8;base64,d09GMgABAAAAABNsAAsAAAAAITAAABMfAAEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHEIGVgCGHAqwBKZJATYCJANwCzoABCAFhG0Hgh8bchtFBoSNA0Bh0xKy/+sEeuzEThXAxNHe+CbdKw6JS4UfbV7d1pk2a2R5maohwz5FIJL707GcfJFBm6GUPMDvj/dcPHwpKYHpu80NDAVUaFDeQltcg/Py+h1K+CDgthHxixMqJYcNT9v8d/cQsQHdvpMKMXsjSgQDPCtYGoVYhY3rxEWl/kWVc1GhkmPWlHPNCNDYGf1K/mNjYx+qdd6cvlZhIBUuhhQ+MUtyPxfHlIt9td92MgRaTvgjBD6DYHBaAQQcrmkx/x2RjposydqRRx+4wNOll/uSUH5C7v/mSjs5QAUliVP8ZeFqVSaLk7zsS8pzjAuUIqmT16rK6laYbHFSTA6zZZaIRqIyFUJUKFVzY90tJYKAuc8sAg/xrJdMSrEUugLac3gCOk34bTuVuw9rZS85QNL5glNHtJblsk9Z0IZq5IzZhKestPE/vgA84Z8+/AdLsxFVybxGtP/kruO2lh1//kzWpklWEqb0GA5nI2ERMuEnWvUZJI0ucqUTM2avAcMCHWsuO8rV8uD55ee3ng88H3z+9MWUzSFu+TdzGrf+qguGWX6TiBxT/R88lVqj1aFTl249evXpFyVZUTXdMC0fQm1oYjeEwyCP9oJXAgJlFxApx4BEuQxkyk2gotwit2plAICGMgi0lKcAckcAHIiAEwlwIQNuFMCDCnjRAAEdEDEACROQsQAFG1BxAA0X0PEAAx9g4gcszDdluVHIHTv+BtyjeQl0RiH/d2RSyyJUNaqxS6OiVuNYGsFKiyqdc4kGI7wW+kNDaj5a8hqrsR2HdZE6BajtHhwOVQuV+lkp/YjBs1Mf7q+nElMch+A8xru6q5rGeImQCquK7oKLPdh+s6iA34c7vkR2uhOtKjixp3J+rIs2OTnlAyuPmt0i+NAudCJl/d6TTfWNNZbvGybx3RDUol8DvcFTFV9rDA2sNYEAw2MOmtYB65trWmvtAkzSE8Sip3gZjIrtD9hE6+KsG4p0iRqTOx7ySYEJ7oReLVslp2JXoxAEepOnKjByvDLCt3FODOZrzemQZA0QSGk+llNIll8BpGQqX1vsDYPQEe8EqG0ksdJUgKINNLDX5JS6eqFa9x1N9Yg0RiENAtjgeCqGV0rtNQPlZc3XqxNqBysnaN0U6LWhgUxEkK91MoazJjmNRQh87Z393n1rvYlCZ+/O3QWRsBG5+1b5rrHmtbZQEdTbhZ9g7Xeu2lcjGqGDaw/cRqiziUJE3UeHXtPt3vN09GNFOGytp63zjdvS5at8Y0OYf5XDsFN4vbR9gswhjnthvOxW7YpT+jZQcYmtr8gNZqivN83GLMJds/m0cHCURLMq15XZWmDS7nx4L9cl1Hs+DcGxQO921F5P6/NPE9JLe/x0tphMFDKpXCzelaDWS11e62VufBpGM8upNCFAgE3Q85TFGsHryTYKsfXKkwjjxJUm/18DvvhKiCPZ5zMkJ4z9WoeIieo7IF7cbK9QJ5QmarUTCR0mx9oM3UlNTZ2JDLOIp3qanzWMsDoBkREFqql+RUXDF9RIjB304jN847pccnkJMcKx8YDOHGpDIHFOjzalSpG6eHlac7baVp+onPgL1Dd/hWrg8WwLObDKXYOXV1y92K4gIAW98iJS8OU1aE7k16F6eqJKyDQkigiB4BFscu9WlF7fHB0CNhXCGqCz9Jlr5BumWItiSjsHuVwf5K54ilz5XgIb555AZ/X0qSno7H4mBLDb2lrPAfty9flICZs2I4tcrs4VKxJpOatYF47RzK3B2yv43WlusW1Q0MxO3c8JSecVq7RUiOVOLmINSz4YEr8CQDHANV09tZ9RMCZ1UZNk6Oz+Gis49UR1Olt34KidapGizdblp40eIw10d2EKoBLGnk6Cu7pNsiWa1gG8cwk1o3SCSCOB9o3s6/Fp2E0oaTApwhTDSYiQY43YRJSS6DGQKDg5FU8pibMOL04bNM0II6Qlj4WuRmB3IiUcm0ePoaPERT24Y9txEp1ZgydlPikQuDXRKmU35+s8hoXQr2N/aPyoupQdNvClGW9RGYtURJ8j1ofSNDhvYWZCUMk1xr5MqrnjkZi8tHCH2XEnZ+Xdol04Kumg0FmWCwdfYbO0M4sMcLpsOmjXJbOZILEXy6XUK8wRy4NMIaEPCltOCJPF7Jg6ncuX+el8XBvgFvsUxhO7Tk6uK/XEeTY9SOXiWp67ck6YLGR6Bt8td55EbontJonfRNcH2HCXOzciNEip+AFbmXgGr7xpt+5OiyklzcJuzd4/5uetnFOwi98lizPcvFaaGxT6RKV0aQYQedLj59aHRZTOt1g5nLEhaoPWwfGj4/PKcI0+2g7hg61sabrp/RP72yPjBsaNeHZvl10lD7ch9HiHXHH9/YShKUMTqKVE+tuHI7FcAzjbCuEjIa4VWhOTB8e3ThiaMNaWLDaEjMbhDbmab4lPGhjXadLo4HgqBWWM4P52xlEoDYuvSz1pSbev1Yzks+lVCXyuuTJ6Y+sM63iytfAMdoVutZQ/+oxi8VXXVi/jZNRr+sVyWGJbnekvOZL/mTZ4/ekjNvcM3/V02joSOHbl2uD561fjGzwvCMLQ93sme6bkaOXZVC8WTxth84uzSzMrYquVXu87rd17WNYAEXlBYFyeX2DYSxlDo3qFZBZ623cQo+96maBCmpITzn51NVETHY+soCNWLHWip/iaa5ih4WoPt81IACmp2xkyliVT8/e35ZQYJLlzuytC5Gr7fDcM9PEBCLtDhJDqG9iO/aQOmGhN3DJuk/zDGUNzhDDtLYOy1EPUHrvbQrnM5+1vFc5w/qyi+L42dA1LaxW82ORIchRLPn4zSNH6K5fJd6n+H1w9rAr6ZViUNlJqb7YWiMGWGrzepMf7K6utU3WRVRem7r17ICw0cKDPP40oXDWlSYkSj6DHh+Oz1VgXk6rV9vfDBpXZha0NxrjWBn89PjhGodXiNMF4vb/BmhuMTbpKPCdn2YHl0oEsAV4P9HhBlrPZebZjbOp+h7T6mjTbwmNEYbpTplZ/rDDNdufGIW1/bKrjbGfz4SO14kv7fPF6HkUaJKXwiLwIBr2OeAJT9xpH332XxCAMTcmrLGPBfxGpVhIGbskDB1LItemgXF2eBUJRs5mREf7bLtDut4CZYSaeQ04h54h9PG3EcLy+T48/lfUH3Mt+mckBPT4vTIakpyMRlAmBzYymvyaSyCxAJPrwqeaFo+NjhQvvaV40XCK2xLMkHOnsC83eXb7foReHQs9VXIjmDxxKVPEvVJwLPfSqZb/WygevzTa8j9UtjUD/hxPR/guAKRz8cp5V6FFvJrPlIZFyzB5j5sDULkkeGVI2Qxq6SngQYunJCvf6aVNDlos2DeORFaXTM9WPEocGdJkxihhGnfS06snZGJ3sHhvSv1lsGxTKeGDUM0xWUbnGCO9egMaexQ8OqcFklRVC6SahRCraJBGdYcEhdxCpsK0UVvq8Z+U8I3x9GBrrKoPG0Mox2eDgU3rzwGBBXR0bjvChbPMZAdnfkOWKuLgk2bSHZPLD0LDPn681mru6SPn5JEXnPozy71JQ8PaNPKk6JNjNDZPNmxsCAnT009laalAGxXBY8ZL/0qjfGoeMeeP+Vn6M3+ASTc2mb2P/KRANytLTds3ApyxNE8UXBsDSnXNJSmLjBIOVsGG8SB8gwbV5qDjBssZYELxg1EhXZYGyY5TmQ5QmECWvWE/b3onKYV47+Hi603KX+WPWF32I0XrpZsUzRoxJBfnJnWuIxB3HzkaAZFf6FCL9As51TY9n+uwHQap+LFBr2CZWspd3uHcv05B3d6JF9douv2UEBwQIgUSLJcjWYhtk4fVuDyzgOkr+6+rm6shtfRMi2WW6fsXv6+sVkffXXEHiw8elIFs7dyPBxuZqEAaJA4PZR++3z8O93/KdamvjbFp44uJWNluJ6UBsen5d/rciiwWskIzSceJoCoosP09GVdDiuPwRYb5a1juW1jdyWy7LfRxVljeZZeUd5YOGHoBPZMWqpAkMd05R+0qKsHsCluRXJnRTh+9iuTMmrJ/A4JEyO47ThGV+SZhvmZCqUZ04PAsvA1PJq3Y6FovlMPOz8y5UWBopBtGlYlTt4i1XkGtocz0cXbeb1DhetNylBhVkq8YhOSA3XkwIjAbHNwHlePmwD3qzLXkX8y9aOilTEye3qrYQF3+51BU7MR6TuuJIS66P6JFJNWlaYgRxMViFDGkx7PKvnWpnyecAZZjbDxieWv6tY6GZG5jHt/1cssNhR03C7DG9it4wrU1w2C74lByRHC74vBNq293qtHU6X57q4yNvOZmBiEevz/wlwcWQVOGcoHlnSXhS8DhuZ9idHZ0F290mT+3gjFlccrPXhuzROU3f9Qmro+MV39szn5Mc4LXBvAGsYqUVG4G2jTMzV3nte/S1hOWcWQlFxqiqLoNziK6rerSyjDx3/EojCZIjT3auPEm2QqWn2v1WUkafdlzEqs+gSv0L424E1Vx2pV5woY0FTMjcCl+9ghLc2gkEjPsz+kCWwOC4Yyox08a4bu9oz5wUh8kyUOP7MzxNm83z1sWVT+opZk2MLfdJMDH22g+QsDyT6afevfx4xbGH9/b+1Z7g6St0W/xqx9CFpe7/+zXPmh1B5I5hT48QuzVGsRg9LH2SbYPLTnt1fB0YiqVIRQUiwZROYDPDLMGg0VgTNGqDST2D1t612DxsvQdzuQoHDkKdExVTKDDKRx1clQg/YhSFgoIxYOJKW8GgoCgR6WwlUeQKKuYEdWnzs67Ls48fnoboaXL4WI78aexrZJoeh/E69qk859gtFpjR4dbv/BlXN412Q3mDtnbmMM+1zxMpSXJPn6/1GD5T8sDp3Qem76s1edR26ZwWrnkp1f+d6p2/a96KKYL/09UZZyvGUee+9GV+eOfEUdzbwobV95asRinm0WA1e8s9xSRhH8kNbG12s35nIPWW9K/76tVd2IPsqUEzIFLrQSmSwQxonOeOcl1/SS/J8M6a7HVOUrA/QbAWaYc4W1t+aOusIPX6Kti6lS/f2lqFW6cOmtUayre1dcRtKdkQZ0Pg+hdKzK5qfAm08KWW4301eIJZUujPJRDsYWBUftTOxcW1z7ued4AlMyg7n3LS4dS6g+2wC9YchpN/dp/u/E+HxBA+B6q4PH5ye1XxaNouxAXnzyltdOP4dn4yjxuo+kxAYkAk2nYtZEvuEuqi2j88FZKbC1QugYX4nVmi+Al+PoIYfi8ZddRkHEz+j/TJOUncuq2It3VYYEe7e8xrwncPsM3O3hmc0mv0Hk253CSJPt/LGOCFFUy2aOgGcRR9WnjItWNRjcfwfKkP74iImrR2qeH49u1K7+2X1ygza2etHHthcwV7w/9PM7Mvz9e5jpQRsVMj96wtigOuw6tOXGudr07SZk8AMgoRE04PGjo6JMQS70kbw62KbtZOBhdxl+ejKcSfcu8SwiKdTTSMNpcW25USFmrvB41TmUvANryNyWXM5qYGpAfdPQ8td4jMC+m0w6HPUJyNCcdSCsZOtwqgGYibOWje6onyNLKZa+bVcmuPJWsSMw1ftsU/BUVz5jUbEYi5As2hg/Ob5I8jYL0sfJI1ehCFBHjFKYhB6mWrnGRB6dKLAZgw+DDu9+98CJm98lGH32cxIX40PiCe+bWq7kSwNvOoon1+vnOOEcRpfpx3kIb2qQQKWgttvpwzPdRBfJ6gAXG5xnxn0ihKOT5ierff6kfIHNzh3789Ghr6wFAf1EMxn3IW1sLghT+k6ZAIAACl6KmKd+iPio/ow4ov6Jm1H0MEGDqUWuJ6sNw/A26jP9MI0PyPXQOwADKJOiOPirfo66rX6Ae/XIvwnpJo14/UB22g7BN6vOYd1MWpeINeqXmPPisbfQX0TFg1+A/tY6EsO1CV6zTyK8Huf+8DbjNKzbxp6FAG5a4iiF4yUiPpz2pvyN1wd/9rBRV3/TskT+7TqKAbQIaiScfN/uCuI4MHZVSHhfb+ja+OGBjVGMdQa1LA5S9iK11WMF5rC7a1AKLPbmcIGAEUsg0APEGngIN+sAVHvT7gpB+cF3K+9/7w1JN/LNx0+Mzve5vnnv+dvRAoBiv1UUaDnbNVfKayT/BrUYjMfj75FyjHVrmaL+29H9ABpWGRd37N7KQjbOW7MDJoGpSJsALD88CcNouFwyznBtvBmRcEKKzMbknaccnIQB23f3bm+PifgNdrKOSz1duSvwDJ4qFLK3PLEMKH0oXaalmM2Y63xoQ5UtqQoJb0ThhoWBeSEn60CjDYXIjRkWwsyN5cWGWev9pOEdUMxG28BjFu4eAREJGQQfxLd1+FCqqoob6xubW9s7u3f3B4dHyiuNzrJuYgCHLfgmDCFI6l6TGDRzoWXjX9fAOOE92gH1POkyZ29YSVz0I1Manj9BRi6Eu3CwYbu9IpAxqxnub6mODcoIWsOqvxUBg2E3Qi18AmCB+5Ubq0FLVGNDCLXU6TkWrL4dLayMURe+41jLbbgveRGWi6h6hRZKMJiiN3hl4PBg==")
    format("woff2");

  /* chrome, firefox, opera, Safari, Android, iOS 4.2+ */

  /* iOS 4.1- */
}

.intro {
  transform: translateY(16vh);
  text-align: center;
}

.nickname {
  font-size: 2em;
  font-weight: normal;
}

.links a {
  padding: 0 5px;
}

.links a:hover {
  background-color: transparent;
}

@media screen and (max-width: 479px) {
  .main {
    padding-top: 0pt;
  }
  .footer {
    height: 0px;
    width: 100%;
    font-size: 12px;
    text-align: center;
    line-height: 1.5rem;
    padding-top: 2em;
    margin-bottom: 45px;
  }
}

.menu.navbar-right {
  text-align: center;
}

.dark-theme .stars {
  z-index: -1;
  position: fixed;
  top: -200px;
  right: -200px;
  width: calc(100vw + 200px);
  height: 0;
  transform: rotate(-35deg);
}

.dark-theme .star {
  opacity: 0;
  --star-color: #ff7f40;
  --star-tail-length: 6em;
  --star-tail-height: 2px;
  --star-width: calc(var(--star-tail-length) / 6);
  --fall-duration: 9s;
  --tail-fade-duration: var(--fall-duration);
  position: absolute;
  top: var(--top-offset);
  left: 0;
  width: var(--star-tail-length);
  height: var(--star-tail-height);
  color: #ff7f40;
  background: linear-gradient(45deg, currentColor, transparent);
  border-radius: 50%;
  filter: drop-shadow(0 0 6px currentColor);
  transform: translate3d(104em, 0, 0);
  animation: fall var(--fall-duration) var(--fall-delay) linear infinite,
    tail-fade var(--tail-fade-duration) var(--fall-delay) ease-out infinite;
}

@media screen and (max-width: 750px) {
  .dark-theme .star {
    animation: fall var(--fall-duration) var(--fall-delay) linear infinite;
  }
}

@keyframes fall {
  to {
    transform: translate3d(-30em, 0, 0);
  }
}

@keyframes tail-fade {
  0% {
    width: 0;
    opacity: 0.3;
  }
  30% {
    width: var(--star-tail-length);
    opacity: 0.6;
  }
  50% {
    width: var(--star-tail-length);
    opacity: 1;
  }
  70% {
    width: var(--star-tail-length);
    opacity: 0.6;
  }
  100% {
    width: 0;
    opacity: 0;
  }
}

@keyframes blink {
  50% {
    opacity: 0.6;
  }
}

.dark-theme .star:nth-child(1) {
  --star-tail-length: 6.07em;
  --top-offset: 18.71vh;
  --fall-duration: 6.295s;
  --fall-delay: 8.613s;
}

.dark-theme .star:nth-child(2) {
  --star-tail-length: 5.87em;
  --top-offset: 91.61vh;
  --fall-duration: 6.744s;
  --fall-delay: 5.299s;
}

.dark-theme .star:nth-child(3) {
  --star-tail-length: 7.01em;
  --top-offset: 66.77vh;
  --fall-duration: 7.356s;
  --fall-delay: 8.793s;
}

.dark-theme .star:nth-child(4) {
  --star-tail-length: 5.54em;
  --top-offset: 3.44vh;
  --fall-duration: 11.193s;
  --fall-delay: 7.602s;
}

.dark-theme .star:nth-child(5) {
  --star-tail-length: 7.37em;
  --top-offset: 30.74vh;
  --fall-duration: 7.323s;
  --fall-delay: 5.879s;
}

.dark-theme .star:nth-child(6) {
  --star-tail-length: 5.74em;
  --top-offset: 96.44vh;
  --fall-duration: 6.375s;
  --fall-delay: 6.784s;
}

.dark-theme .star:nth-child(7) {
  --star-tail-length: 6.75em;
  --top-offset: 53.58vh;
  --fall-duration: 11.154s;
  --fall-delay: 2.304s;
}

.dark-theme .star:nth-child(8) {
  --star-tail-length: 6.93em;
  --top-offset: 45.4vh;
  --fall-duration: 9.916s;
  --fall-delay: 1.499s;
}

.dark-theme .star:nth-child(9) {
  --star-tail-length: 6.79em;
  --top-offset: 4.57vh;
  --fall-duration: 6.47s;
  --fall-delay: 3.746s;
}

.dark-theme .star:nth-child(10) {
  --star-tail-length: 7.16em;
  --top-offset: 87.24vh;
  --fall-duration: 10.807s;
  --fall-delay: 3.084s;
}

.dark-theme .star:nth-child(11) {
  --star-tail-length: 5.29em;
  --top-offset: 16.51vh;
  --fall-duration: 8.055s;
  --fall-delay: 1.882s;
}

.dark-theme .star:nth-child(12) {
  --star-tail-length: 5.48em;
  --top-offset: 88.17vh;
  --fall-duration: 6.439s;
  --fall-delay: 4.72s;
}

.dark-theme .star:nth-child(13) {
  --star-tail-length: 5.42em;
  --top-offset: 99.99vh;
  --fall-duration: 10.565s;
  --fall-delay: 9.969s;
}

.dark-theme .star:nth-child(14) {
  --star-tail-length: 6.45em;
  --top-offset: 66.41vh;
  --fall-duration: 6.242s;
  --fall-delay: 4.135s;
}

.dark-theme .star:nth-child(15) {
  --star-tail-length: 6.1em;
  --top-offset: 33.08vh;
  --fall-duration: 9.203s;
  --fall-delay: 5.222s;
}

.dark-theme .star:nth-child(16) {
  --star-tail-length: 5.31em;
  --top-offset: 71.71vh;
  --fall-duration: 8.738s;
  --fall-delay: 0.224s;
}

.dark-theme .star:nth-child(17) {
  --star-tail-length: 5.18em;
  --top-offset: 96.06vh;
  --fall-duration: 11.629s;
  --fall-delay: 4.021s;
}

.dark-theme .star:nth-child(18) {
  --star-tail-length: 6.82em;
  --top-offset: 79.65vh;
  --fall-duration: 6.07s;
  --fall-delay: 0.699s;
}

.dark-theme .star:nth-child(19) {
  --star-tail-length: 7.45em;
  --top-offset: 50.02vh;
  --fall-duration: 9.895s;
  --fall-delay: 5.542s;
}

.dark-theme .star:nth-child(20) {
  --star-tail-length: 5.29em;
  --top-offset: 81.84vh;
  --fall-duration: 6.928s;
  --fall-delay: 2.042s;
}

.dark-theme .star:nth-child(21) {
  --star-tail-length: 5.99em;
  --top-offset: 42.27vh;
  --fall-duration: 7.946s;
  --fall-delay: 4.317s;
}

.dark-theme .star:nth-child(22) {
  --star-tail-length: 6.49em;
  --top-offset: 0.55vh;
  --fall-duration: 10.794s;
  --fall-delay: 9.025s;
}

.dark-theme .star:nth-child(23) {
  --star-tail-length: 6.42em;
  --top-offset: 42vh;
  --fall-duration: 8.135s;
  --fall-delay: 6.336s;
}

.dark-theme .star:nth-child(24) {
  --star-tail-length: 5.07em;
  --top-offset: 56.93vh;
  --fall-duration: 11.157s;
  --fall-delay: 2.912s;
}

.dark-theme .star:nth-child(25) {
  --star-tail-length: 6.56em;
  --top-offset: 65.69vh;
  --fall-duration: 9.641s;
  --fall-delay: 0.982s;
}

.dark-theme .star:nth-child(26) {
  --star-tail-length: 6.5em;
  --top-offset: 80.77vh;
  --fall-duration: 6.756s;
  --fall-delay: 5.443s;
}

.dark-theme .star:nth-child(27) {
  --star-tail-length: 6.01em;
  --top-offset: 30.77vh;
  --fall-duration: 7.305s;
  --fall-delay: 8.435s;
}

.dark-theme .star:nth-child(28) {
  --star-tail-length: 6.74em;
  --top-offset: 57.09vh;
  --fall-duration: 10.082s;
  --fall-delay: 9.389s;
}

.dark-theme .star:nth-child(29) {
  --star-tail-length: 6.09em;
  --top-offset: 65.11vh;
  --fall-duration: 6.587s;
  --fall-delay: 6.4s;
}

.dark-theme .star:nth-child(30) {
  --star-tail-length: 7.49em;
  --top-offset: 92.88vh;
  --fall-duration: 10.762s;
  --fall-delay: 2.241s;
}

.dark-theme .star:nth-child(31) {
  --star-tail-length: 5.77em;
  --top-offset: 97.66vh;
  --fall-duration: 10.42s;
  --fall-delay: 4.185s;
}

.dark-theme .star:nth-child(32) {
  --star-tail-length: 7.1em;
  --top-offset: 48.23vh;
  --fall-duration: 9.418s;
  --fall-delay: 0.79s;
}

.dark-theme .star:nth-child(33) {
  --star-tail-length: 5.06em;
  --top-offset: 70.09vh;
  --fall-duration: 6.436s;
  --fall-delay: 2.047s;
}

.dark-theme .star:nth-child(34) {
  --star-tail-length: 5.35em;
  --top-offset: 47.6vh;
  --fall-duration: 8.384s;
  --fall-delay: 4.431s;
}

.dark-theme .star:nth-child(35) {
  --star-tail-length: 6.5em;
  --top-offset: 35.5vh;
  --fall-duration: 9.579s;
  --fall-delay: 2.685s;
}

.dark-theme .star:nth-child(36) {
  --star-tail-length: 5.31em;
  --top-offset: 78.83vh;
  --fall-duration: 10.381s;
  --fall-delay: 0.631s;
}

.dark-theme .star:nth-child(37) {
  --star-tail-length: 7.45em;
  --top-offset: 75.7vh;
  --fall-duration: 6.924s;
  --fall-delay: 6.499s;
}

.dark-theme .star:nth-child(38) {
  --star-tail-length: 6.71em;
  --top-offset: 50.78vh;
  --fall-duration: 8.385s;
  --fall-delay: 6.098s;
}

.dark-theme .star:nth-child(39) {
  --star-tail-length: 5.03em;
  --top-offset: 36.46vh;
  --fall-duration: 9.385s;
  --fall-delay: 6.252s;
}

.dark-theme .star:nth-child(40) {
  --star-tail-length: 5.58em;
  --top-offset: 86.88vh;
  --fall-duration: 7.07s;
  --fall-delay: 0.626s;
}

.dark-theme .star:nth-child(41) {
  --star-tail-length: 5.75em;
  --top-offset: 16.67vh;
  --fall-duration: 8.02s;
  --fall-delay: 1.497s;
}

.dark-theme .star:nth-child(42) {
  --star-tail-length: 7.08em;
  --top-offset: 56.93vh;
  --fall-duration: 9.208s;
  --fall-delay: 5.358s;
}

.dark-theme .star:nth-child(43) {
  --star-tail-length: 5.6em;
  --top-offset: 73.67vh;
  --fall-duration: 6.207s;
  --fall-delay: 3.243s;
}

.dark-theme .star:nth-child(44) {
  --star-tail-length: 5.45em;
  --top-offset: 25.2vh;
  --fall-duration: 10.599s;
  --fall-delay: 8.583s;
}

.dark-theme .star:nth-child(45) {
  --star-tail-length: 7.14em;
  --top-offset: 56.77vh;
  --fall-duration: 11.523s;
  --fall-delay: 9.923s;
}

.dark-theme .star:nth-child(46) {
  --star-tail-length: 5.22em;
  --top-offset: 10.01vh;
  --fall-duration: 8.072s;
  --fall-delay: 0.293s;
}

.dark-theme .star:nth-child(47) {
  --star-tail-length: 7.44em;
  --top-offset: 87.25vh;
  --fall-duration: 9.226s;
  --fall-delay: 2.065s;
}

.dark-theme .star:nth-child(48) {
  --star-tail-length: 7.43em;
  --top-offset: 68.32vh;
  --fall-duration: 11.421s;
  --fall-delay: 7.182s;
}

.dark-theme .star:nth-child(49) {
  --star-tail-length: 5.68em;
  --top-offset: 56.42vh;
  --fall-duration: 9.508s;
  --fall-delay: 7.669s;
}

.dark-theme .star:nth-child(50) {
  --star-tail-length: 5.37em;
  --top-offset: 93.45vh;
  --fall-duration: 10.222s;
  --fall-delay: 4.175s;
}

.dark-theme .star::before,
.dark-theme .star::after {
  position: absolute;
  content: "";
  top: 0;
  left: calc(var(--star-width) / -2);
  width: var(--star-width);
  height: 100%;
  background: linear-gradient(45deg, transparent, currentColor, transparent);
  border-radius: inherit;
  animation: blink 2s linear infinite;
}

.dark-theme .star::before {
  transform: rotate(45deg);
}

.dark-theme .star::after {
  transform: rotate(-45deg);
}

.stars {
  z-index: -1;
  position: fixed;
  top: -200px;
  right: -200px;
  width: calc(100vw + 200px);
  height: 0px;
  transform: rotate(-35deg);
}

.star {
  opacity: 0;
  --star-tail-length: 6em;
  --star-tail-height: 2px;
  --star-width: calc(var(--star-tail-length) / 6);
  --fall-duration: 9s;
  --tail-fade-duration: var(--fall-duration);
  position: absolute;
  top: var(--top-offset);
  left: 0;
  width: var(--star-tail-length);
  height: var(--star-tail-height);
  color: var(--star-color);
  background: linear-gradient(45deg, currentColor, transparent);
  border-radius: 50%;
  filter: drop-shadow(0 0 6px currentColor);
  transform: translate3d(104em, 0, 0);
  animation: fall var(--fall-duration) var(--fall-delay) linear infinite,
    tail-fade var(--tail-fade-duration) var(--fall-delay) ease-out infinite;
}

@media screen and (max-width: 750px) {
  .star {
    animation: fall var(--fall-duration) var(--fall-delay) linear infinite;
  }
}

.star:nth-child(1) {
  --star-tail-length: 6.07em;
  --top-offset: 18.71vh;
  --fall-duration: 6.295s;
  --fall-delay: 8.613s;
}

.star:nth-child(2) {
  --star-tail-length: 5.87em;
  --top-offset: 91.61vh;
  --fall-duration: 6.744s;
  --fall-delay: 5.299s;
}

.star:nth-child(3) {
  --star-tail-length: 7.01em;
  --top-offset: 66.77vh;
  --fall-duration: 7.356s;
  --fall-delay: 8.793s;
}

.star:nth-child(4) {
  --star-tail-length: 5.54em;
  --top-offset: 3.44vh;
  --fall-duration: 11.193s;
  --fall-delay: 7.602s;
}

.star:nth-child(5) {
  --star-tail-length: 7.37em;
  --top-offset: 30.74vh;
  --fall-duration: 7.323s;
  --fall-delay: 5.879s;
}

.star:nth-child(6) {
  --star-tail-length: 5.74em;
  --top-offset: 96.44vh;
  --fall-duration: 6.375s;
  --fall-delay: 6.784s;
}

.star:nth-child(7) {
  --star-tail-length: 6.75em;
  --top-offset: 53.58vh;
  --fall-duration: 11.154s;
  --fall-delay: 2.304s;
}

.star:nth-child(8) {
  --star-tail-length: 6.93em;
  --top-offset: 45.4vh;
  --fall-duration: 9.916s;
  --fall-delay: 1.499s;
}

.star:nth-child(9) {
  --star-tail-length: 6.79em;
  --top-offset: 4.57vh;
  --fall-duration: 6.47s;
  --fall-delay: 3.746s;
}

.star:nth-child(10) {
  --star-tail-length: 7.16em;
  --top-offset: 87.24vh;
  --fall-duration: 10.807s;
  --fall-delay: 3.084s;
}

.star:nth-child(11) {
  --star-tail-length: 5.29em;
  --top-offset: 16.51vh;
  --fall-duration: 8.055s;
  --fall-delay: 1.882s;
}

.star:nth-child(12) {
  --star-tail-length: 5.48em;
  --top-offset: 88.17vh;
  --fall-duration: 6.439s;
  --fall-delay: 4.72s;
}

.star:nth-child(13) {
  --star-tail-length: 5.42em;
  --top-offset: 99.99vh;
  --fall-duration: 10.565s;
  --fall-delay: 9.969s;
}

.star:nth-child(14) {
  --star-tail-length: 6.45em;
  --top-offset: 66.41vh;
  --fall-duration: 6.242s;
  --fall-delay: 4.135s;
}

.star:nth-child(15) {
  --star-tail-length: 6.1em;
  --top-offset: 33.08vh;
  --fall-duration: 9.203s;
  --fall-delay: 5.222s;
}

.star:nth-child(16) {
  --star-tail-length: 5.31em;
  --top-offset: 71.71vh;
  --fall-duration: 8.738s;
  --fall-delay: 0.224s;
}

.star:nth-child(17) {
  --star-tail-length: 5.18em;
  --top-offset: 96.06vh;
  --fall-duration: 11.629s;
  --fall-delay: 4.021s;
}

.star:nth-child(18) {
  --star-tail-length: 6.82em;
  --top-offset: 79.65vh;
  --fall-duration: 6.07s;
  --fall-delay: 0.699s;
}

.star:nth-child(19) {
  --star-tail-length: 7.45em;
  --top-offset: 50.02vh;
  --fall-duration: 9.895s;
  --fall-delay: 5.542s;
}

.star:nth-child(20) {
  --star-tail-length: 5.29em;
  --top-offset: 81.84vh;
  --fall-duration: 6.928s;
  --fall-delay: 2.042s;
}

.star:nth-child(21) {
  --star-tail-length: 5.99em;
  --top-offset: 42.27vh;
  --fall-duration: 7.946s;
  --fall-delay: 4.317s;
}

.star:nth-child(22) {
  --star-tail-length: 6.49em;
  --top-offset: 0.55vh;
  --fall-duration: 10.794s;
  --fall-delay: 9.025s;
}

.star:nth-child(23) {
  --star-tail-length: 6.42em;
  --top-offset: 42vh;
  --fall-duration: 8.135s;
  --fall-delay: 6.336s;
}

.star:nth-child(24) {
  --star-tail-length: 5.07em;
  --top-offset: 56.93vh;
  --fall-duration: 11.157s;
  --fall-delay: 2.912s;
}

.star:nth-child(25) {
  --star-tail-length: 6.56em;
  --top-offset: 65.69vh;
  --fall-duration: 9.641s;
  --fall-delay: 0.982s;
}

.star:nth-child(26) {
  --star-tail-length: 6.5em;
  --top-offset: 80.77vh;
  --fall-duration: 6.756s;
  --fall-delay: 5.443s;
}

.star:nth-child(27) {
  --star-tail-length: 6.01em;
  --top-offset: 30.77vh;
  --fall-duration: 7.305s;
  --fall-delay: 8.435s;
}

.star:nth-child(28) {
  --star-tail-length: 6.74em;
  --top-offset: 57.09vh;
  --fall-duration: 10.082s;
  --fall-delay: 9.389s;
}

.star:nth-child(29) {
  --star-tail-length: 6.09em;
  --top-offset: 65.11vh;
  --fall-duration: 6.587s;
  --fall-delay: 6.4s;
}

.star:nth-child(30) {
  --star-tail-length: 7.49em;
  --top-offset: 92.88vh;
  --fall-duration: 10.762s;
  --fall-delay: 2.241s;
}

.star:nth-child(31) {
  --star-tail-length: 5.77em;
  --top-offset: 97.66vh;
  --fall-duration: 10.42s;
  --fall-delay: 4.185s;
}

.star:nth-child(32) {
  --star-tail-length: 7.1em;
  --top-offset: 48.23vh;
  --fall-duration: 9.418s;
  --fall-delay: 0.79s;
}

.star:nth-child(33) {
  --star-tail-length: 5.06em;
  --top-offset: 70.09vh;
  --fall-duration: 6.436s;
  --fall-delay: 2.047s;
}

.star:nth-child(34) {
  --star-tail-length: 5.35em;
  --top-offset: 47.6vh;
  --fall-duration: 8.384s;
  --fall-delay: 4.431s;
}

.star:nth-child(35) {
  --star-tail-length: 6.5em;
  --top-offset: 35.5vh;
  --fall-duration: 9.579s;
  --fall-delay: 2.685s;
}

.star:nth-child(36) {
  --star-tail-length: 5.31em;
  --top-offset: 78.83vh;
  --fall-duration: 10.381s;
  --fall-delay: 0.631s;
}

.star:nth-child(37) {
  --star-tail-length: 7.45em;
  --top-offset: 75.7vh;
  --fall-duration: 6.924s;
  --fall-delay: 6.499s;
}

.star:nth-child(38) {
  --star-tail-length: 6.71em;
  --top-offset: 50.78vh;
  --fall-duration: 8.385s;
  --fall-delay: 6.098s;
}

.star:nth-child(39) {
  --star-tail-length: 5.03em;
  --top-offset: 36.46vh;
  --fall-duration: 9.385s;
  --fall-delay: 6.252s;
}

.star:nth-child(40) {
  --star-tail-length: 5.58em;
  --top-offset: 86.88vh;
  --fall-duration: 7.07s;
  --fall-delay: 0.626s;
}

.star:nth-child(41) {
  --star-tail-length: 5.75em;
  --top-offset: 16.67vh;
  --fall-duration: 8.02s;
  --fall-delay: 1.497s;
}

.star:nth-child(42) {
  --star-tail-length: 7.08em;
  --top-offset: 56.93vh;
  --fall-duration: 9.208s;
  --fall-delay: 5.358s;
}

.star:nth-child(43) {
  --star-tail-length: 5.6em;
  --top-offset: 73.67vh;
  --fall-duration: 6.207s;
  --fall-delay: 3.243s;
}

.star:nth-child(44) {
  --star-tail-length: 5.45em;
  --top-offset: 25.2vh;
  --fall-duration: 10.599s;
  --fall-delay: 8.583s;
}

.star:nth-child(45) {
  --star-tail-length: 7.14em;
  --top-offset: 56.77vh;
  --fall-duration: 11.523s;
  --fall-delay: 9.923s;
}

.star:nth-child(46) {
  --star-tail-length: 5.22em;
  --top-offset: 10.01vh;
  --fall-duration: 8.072s;
  --fall-delay: 0.293s;
}

.star:nth-child(47) {
  --star-tail-length: 7.44em;
  --top-offset: 87.25vh;
  --fall-duration: 9.226s;
  --fall-delay: 2.065s;
}

.star:nth-child(48) {
  --star-tail-length: 7.43em;
  --top-offset: 68.32vh;
  --fall-duration: 11.421s;
  --fall-delay: 7.182s;
}

.star:nth-child(49) {
  --star-tail-length: 5.68em;
  --top-offset: 56.42vh;
  --fall-duration: 9.508s;
  --fall-delay: 7.669s;
}

.star:nth-child(50) {
  --star-tail-length: 5.37em;
  --top-offset: 93.45vh;
  --fall-duration: 10.222s;
  --fall-delay: 4.175s;
}

.star::before,
.star::after {
  position: absolute;
  content: "";
  top: 0;
  left: calc(var(--star-width) / -2);
  width: var(--star-width);
  height: 100%;
  background: linear-gradient(45deg, transparent, currentColor, transparent);
  border-radius: inherit;
  animation: blink 2s linear infinite;
}

.star::before {
  transform: rotate(45deg);
}

.star::after {
  transform: rotate(-45deg);
}

@keyframes fall {
  to {
    transform: translate3d(-30em, 0, 0);
  }
}

@keyframes tail-fade {
  0% {
    width: 0;
    opacity: 0.3;
  }
  30% {
    width: var(--star-tail-length);
    opacity: 0.6;
  }
  50% {
    width: var(--star-tail-length);
    opacity: 1;
  }
  70% {
    width: var(--star-tail-length);
    opacity: 0.6;
  }
  100% {
    width: 0;
    opacity: 0;
  }
}

@keyframes blink {
  50% {
    opacity: 0.6;
  }
}

.list,
.list li {
  list-style: none;
  list-style-type: none;
  margin: 0px;
  padding: 0px;
}

.tr3 {
  transition: all 0.3s;
}

#donateBox {
  left: calc(50% - 150px);
  top: calc(50% - 15px);
  border-radius: 6px;
  width: 100%;
  display: flex;
  justify-content: center;
  height: 40px;
  z-index: 1;
}

#donateBox li {
  width: 150px;
  height: 40px;
  float: left;
  text-align: center;
  background: no-repeat center center;
  background-size: 45px;
  transition: all 0.3s;
  cursor: pointer;
  overflow: hidden;
  line-height: 600px;
  -webkit-filter: grayscale(1);
  filter: grayscale(1);
  opacity: 0.5;
}

.dark-theme #donateBox li {
  -webkit-filter: grayscale(0);
  filter: grayscale(0);
  opacity: 1;
}

#donateBox li:hover {
  -webkit-filter: grayscale(0);
  filter: grayscale(0);
  opacity: 1;
}

#donateBox > li:first-child {
  border-width: 0;
}

#donateBox #QQ {
  background-image: url(../img/qq.svg);
}

#donateBox #AliPay {
  background-image: url(../img/alipay.svg);
}

#donateBox #WeChat {
  background-image: url(../img/wechat.svg);
}

.dark-theme #donateBox #QQ {
  background-image: url(../img/qq1.svg);
}

.dark-theme #donateBox #AliPay {
  background-image: url(../img/alipay1.svg);
}

.dark-theme #donateBox #WeChat {
  background-image: url(../img/wechat1.svg);
}

#QRBox {
  top: 0;
  left: 0;
  z-index: 1;
  display: none;
  perspective: 400px;
}

#MainBox {
  cursor: pointer;
  position: absolute;
  z-index: 9;
  text-align: center;
  width: 200px;
  height: 200px;
  left: calc(50% - 100px);
  top: calc(50% - 100px);
  background: #fff no-repeat center center;
  background-size: 190px;
  border-radius: 6px;
  box-shadow: 0px 2px 7px rgba(0, 0, 0, 0.3);
  opacity: 0;
  transition: all 1s ease-in-out;
  transform-style: preserve-3d;
  transform-origin: center center;
  overflow: hidden;
}

#github {
  width: 24px;
  height: 24px;
  left: calc(50% + 135px);
  top: calc(50% - 30px);
  background: no-repeat center center
    url(https://cdn.jsdelivr.net/gh/nuoxianCN/cdn@1.0.4/pay/images/github.svg);
  background-size: contain;
  opacity: 0.3;
  transform: rotatez(15deg);
}

[data-footnote] {
  position: relative;
  overflow: hidden;
}

[data-footnote]:hover {
  overflow: visible;
}

[data-footnote]::before,
[data-footnote]::after {
  position: absolute;
  transition: all 0.3s;
  transform: translate3d(-50%, 0, 0);
  opacity: 0;
  left: 37px;
  z-index: 10;
}

[data-footnote]::before {
  content: attr(data-footnote);
  border-radius: 6px;
  background-color: rgba(100, 100, 100, 0.8);
  color: #fff;
  height: 24px;
  line-height: 24px;
  padding: 0 6px;
  font-size: 12px;
  white-space: nowrap;
  top: -24px;
  left: 37px;
}

[data-footnote]::after {
  content: "";
  border: 5px solid #333;
  border-color: rgba(100, 100, 100, 0.8) transparent transparent transparent;
  top: 0;
  left: 37px;
}

[data-footnote]:hover::before,
[data-footnote]:hover::after {
  opacity: 1;
}

[data-footnote]:hover::before,
[data-footnote]:hover::after {
  transform: translate3d(-50%, -7px, 0);
}

#MainBox.showQR {
  opacity: 1;
  animation-name: showQR;
  animation-duration: 3s;
  animation-timing-function: ease-in-out;
  animation-iteration-count: 1;
  animation-fill-mode: forwards;
  -webkit-animation: showQR 1s ease-in-out 0s 1 normal forwards;
}

@keyframes showQR {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

#MainBox.hideQR {
  opacity: 1;
  animation-name: hideQR;
  animation-duration: 0.5s;
  animation-timing-function: ease-in-out;
  animation-iteration-count: 1;
  animation-fill-mode: forwards;
  -webkit-animation: hideQR 0.5s ease-in-out 0s 1 normal forwards;
}

@keyframes hideQR {
  from {
  }
  20%,
  50% {
    transform: scale(1.08, 1.08);
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: rotateZ(40deg) scale(0.6, 0.6);
  }
}
</style>
